<template>
  <div 
    class="time-bar" 
    ref="timeBar"
    
    @mousemove="handleMousemove"
    @mouseup="handleMouseup"

    @mouseenter="handleRowMouseenter"
    @mouseleave="handleRowMouseleave"
    @mousedown="handleRowMousedown"

    :style="{'z-index': (draging || creating) ? 1 : 'inherit'}"
  > 
    <!-- 进行新增、修改拖动时，该时间条的底板 -->
    <div v-if="draging || creating" class="draging-back-warp" />

    <!-- 时间条 -->
    <div 
      class="bar-warp" 
      v-for="(bar, index) in barData" 
      :key="bar.id"
      :style="{
        left: `${bar.offset}px`, 
        width: `${bar.span}px`, 
        'z-index': bar.moving ? 2 : 'inherit',
      }"

      @dblclick.left.stop="handleShowTimeRangePicker(bar)"
      @click.right.stop="e => handleBarMouseupRight(bar)"        
      @mouseenter="e => handleBarMouseenter(bar, e)"
      @mouseleave="e => handleBarMouseleave(bar)"

      @contextmenu.prevent
    > 
      <!-- 时间条显示 -->
      <div 
        class="bar" 
        :style="{
          top: bar.moving ? '8px' : '12px',
          bottom: bar.moving ? '8px' : '12px'
        }"
      > 
        <!-- 时间条删除功能弹窗 -->
        <a-popconfirm
          :placement="deleteBarPopPlace"
          :title="$t('timeConfig.deleteTimeRangeWarning')"
          :okText="$t('timeConfig.deleteBtn')"
          :cancelText="$t('timeConfig.cancelBtn')"
          @confirm="handleDeleteTimeBar(bar)"
        ><div :ref="`delete-${bar.id}`"></div>
        </a-popconfirm>

        <!-- 时间段文字hover提示框 -->
        <a-tooltip placement="top">
          <span class="time-str">{{bar.fromTime.substr(0,5) + ' ~ ' + bar.toTime.substr(0,5) }}</span>
          <template slot="title">
            <p style="margin:0">{{bar.fromTime.substr(0,5)  + ' ~ ' + bar.toTime.substr(0,5) }}</p>
          </template>
        </a-tooltip>
      </div>

      <!-- 修改时间条时的拖动按钮 -->
      <a-icon
        v-if="bar.hover"
        class="drag-btn left"
        type="caret-left"
        @mousedown="e => handleBarMousedown(e, bar, 'left')"
      />
      <a-icon
        v-if="bar.hover"
        class="drag-btn right"
        type="caret-right"
        @mousedown="e => handleBarMousedown(e, bar, 'right')"
      />
    </div>
    <!-- 新增时间 -->
    <div 
      v-if="rowHover"
      class="new-time-bar" 
      :style="{left: newBarOffset+'px', width: newBarWidth+'px', 'z-index': creating ? 2 : 'inherit'}"
    >
      <span class="time-flag" v-if="newFromTime">{{newFromTime.substr(0, 5)}}</span>
      <span class="time-flag end" v-if="newToTime">{{newToTime.substr(0, 5)}}</span>
    </div>

    <!-- 时间范围选择框 -->
    <div v-if="pickerVisible" class="time-bar-edit" :style="pickerPosition">
      <div class="time-range-picker">
        <a-time-picker
          inputReadOnly
          size="small"
          popupClassName="form-select"
          :getPopupContainer="trigger => trigger.parentNode"
          :style="{marginRight: '5px', width: '120px'}"
          :placeholder="$t('timeConfig.pickerFromTimeTxt')"
          format="HH:mm"
          v-model="setFromTime"
          @change="validTimeRange"
          @openChange="open => open && (setTimeError = '')"
        />
        <span style="color:#333"> - </span>
        <a-time-picker
          inputReadOnly
          size="small"
          popupClassName="form-select"
          :getPopupContainer="trigger => trigger.parentNode"
          :style="{marginLeft: '5px'}"
          :placeholder="$t('timeConfig.pickerToTimeTxt')"
          format="HH:mm"
          v-model="setToTime"
          @change="validTimeRange"
          @openChange="open => open && (setTimeError = '')"
        />
        <a-button 
          size="small" 
          style="margin: 0 10px" 
          @click="handleCloseTimeRangePicker"
        >{{$t('timeConfig.cancelBtn')}}</a-button>
        <a-button 
          size="small" 
          type="primary"
          :disabled="Boolean(setTimeError) || !setFromTime || !setToTime"
          @click="handleConfirmTimeRange"
        >{{$t('timeConfig.comfirmBtn')}}</a-button>
      </div>
      <span v-if="setTimeError" class="error-msg">{{$t(setTimeError)}}</span>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { numberToLenStr, getUuid } from '@/utils/utils'
export default {
  name: 'TimeBar',
  components: {},
  props: {
    times: {
      type: Array,
      require: true
    },
    extend: {
      type: Number,
      default: 0
    },
    pickerVisible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      timeBarWidth: 0,
      perW: 1,
      barData: [],

      targetBar: null,

      // 时间选择器
      pickerPosition: {},
      setTimeError: '',
      setFromTime: null,
      setToTime: null,

      // 滑动新增
      rowHover: false,
      creating: false,
      newBarOffset: 0,
      newBarWidth: 2,
      newFromTime: '',
      newToTime: '',
      createDownState: {
        startPageX: 0,
        startOffset: 0,
        startTimeStr: ''
      },

      // 拖动修改时间条
      draging: false,
      dragBtnVisible: false,
      dragBtnL: {},
      dragBtnR: {},
      dragBtnDownState: {
        startPageX: 0,
        offset: 0,
        span: 0,
        direct: ''
      },

      // 删除时间条
      deleteBarPopPlace: 'top'
    }
  },
  computed: {},
  watch: {
    times: function(newTimes) {
      this.getBarData(newTimes)
    }
  },
  mounted() {
    this.$nextTick(() => {
      // this.getPerMinuteWidth()
      this.getBarData(this.times)
    })
  },
  methods: {
    getPerMinuteWidth() {
      this.timeBarWidth = this.$refs.timeBar.getBoundingClientRect().width - (2 * this.extend)
      this.perW = parseFloat(this.timeBarWidth / 1440)
    },
    getBarData(times) {
      const barData = []
      times.forEach(time => {
        const [fH, fM] = time.fromTime.split(':').map(item => Number(item))
        let [tH, tM] = time.toTime.split(':').map(item => Number(item))
        if (tH === 0 && tM === 0) tH = 24
        const start = fH + parseFloat(fM / 60, 2)
        const end = tH + parseFloat(tM / 60, 2)
        barData.push({
          ...time,
          moving: false,
          hover: false,
          offset: start * 60,
          span: (end - start) * 60,
          id: getUuid()
        })
      })
      this.barData = barData
    },

    handleMousemove(e) {
      if (this.draging) {
        this.handleBarMousemove(e)
      } else if (this.rowHover) {
        this.handleRowMousemove(e)
      }
    },
    handleMouseup(e) {
      if (this.draging) this.handleBarMouseup(e)
      if (this.creating) this.handleRowMouseup(e)
    },

    // ------------------ 表格行中拖动鼠标新增时间条 -------------------
    handleRowMouseenter(e) {
      if (!this.draging && !this.creating) {
        this.rowHover = true
      }
    },
    handleRowMouseleave(e) {
      if (!this.draging && !this.creating) {
        this.rowHover = false
      }
    },
    handleRowMousedown(e) {
      if (this.rowHover) {
        this.handleCloseTimeRangePicker()

        this.createDownState.startPageX = e.pageX
        this.createDownState.startOffset = this.newBarOffset
        this.createDownState.startTimeStr = this.newFromTime

        this.creating = true
      }
    },
    handleRowMousemove(e) {
      if (!this.creating) {
        this.setNewBarOffsetLeft(e)
      } else {
        const { startPageX, startOffset, startTimeStr } = this.createDownState
        let distance = e.pageX - startPageX
        if (distance > 0) {
          const { newSpan, newOffset } = this.fixedOffsetAndSpan(startOffset, distance)
          this.newBarOffset = newOffset
          this.newBarWidth = newSpan
          this.newFromTime = startTimeStr
          this.newToTime = this.calculateTimeStr(newOffset + newSpan)
        } else {
          const { newSpan, newOffset } = this.fixedOffsetAndSpan(startOffset + distance, Math.abs(distance))
          this.newBarOffset = newOffset
          this.newBarWidth = newSpan
          this.newFromTime = this.calculateTimeStr(newOffset)
          this.newToTime = startTimeStr
        }
      }
    },
    setNewBarOffsetLeft(e) {
      if (e.target === e.currentTarget) {
        let offset = e.offsetX
        if (offset < 0) offset = 0
        if (offset > 1440) offset = 1440
        this.newBarOffset = e.offsetX
        this.newFromTime = this.calculateTimeStr(this.newBarOffset)
      }
    },
    handleRowMouseup(e) {
      if (this.newBarWidth > 10) {
        this.barData.push({ 
          fromTime: this.newFromTime, 
          toTime: this.newToTime
        })
        // 抛出最新的时间段内容
        this.$emit('changeTimes', this.handleOverlapRange(this.barData))
      }

      this.creating = false
      this.rowHover = false

      this.newBarWidth = 2
      this.newBarOffset = 0
      this.newFromTime = ''
      this.newToTime = ''
      this.createDownState = {
        startPageX: 0,
        startOffset: 0,
        startTimeStr: ''
      }
    },

    // ---------------------------------------------------------

    // ------------------ 拖动时间条来修改时间条 -------------------
    handleBarMouseenter(bar, e) {
      if (!this.draging && !this.creating) {
        this.rowHover = false
        bar.hover = true
      }
    },
    handleBarMouseleave(bar) {
      if (!this.draging && !this.creating) {
        this.rowHover = true
        bar.hover = false
      }
    },
    handleBarMousedown(e, bar, direct) {
      this.handleCloseTimeRangePicker()

      this.draging = true
      this.targetBar = bar
      this.targetBar.moving = true

      this.dragBtnDownState.startPageX = e.pageX
      this.dragBtnDownState.span = bar.span
      this.dragBtnDownState.offset = bar.offset
      this.dragBtnDownState.direct = direct
    },
    handleBarMousemove(e) {
      let { startPageX, offset, span, direct } = this.dragBtnDownState
      let distance = e.pageX - startPageX
      if (direct === 'left') {
        span -= distance
        offset += distance
      } else {
        span += distance
      }
      const { newSpan, newOffset } = this.fixedOffsetAndSpan(offset, span, direct)

      this.targetBar.offset = newOffset
      this.targetBar.span = newSpan
      this.targetBar.fromTime = this.calculateTimeStr(this.targetBar.offset)
      this.targetBar.toTime = this.calculateTimeStr(this.targetBar.span + this.targetBar.offset)
    },
    handleBarMouseup(e) {
      // 抛出最新的时间段内容
      this.$emit('changeTimes', this.handleOverlapRange(this.barData))

      this.draging = false
      this.targetBar.moving = false
      this.targetBar = null
      
      this.dragBtnDownState.startPageX = 0
      this.dragBtnDownState.span = 0
      this.dragBtnDownState.offset = 0
      this.dragBtnDownState.direct = ''
    },    
    // ------------------------------------------------
    
    calculateTimeStr(minutes) {
      minutes = Math.ceil(minutes)
      if (minutes < 0) minutes = 0
      if (minutes > 1440) minutes = 1440

      const hour = Math.floor(minutes / 60) % 24
      const minute = minutes % 60
      return numberToLenStr(hour, 2) + ':' + numberToLenStr(minute, 2) + ':00'
    },
    // 拖动时的边界值修正
    fixedOffsetAndSpan(offset, span, direct) {
      let newOffset = offset, newSpan = span;

      if (newOffset < 0) {
        newOffset = 0
        newSpan = span + offset
      }
      if (newOffset + newSpan > 1440) {
        newSpan = 1440 - newOffset
      }
      if (newSpan < 10 && direct) {
        newSpan = 10
        if (direct === 'left') {
          newOffset = offset + span - 10
        } else if (direct === 'right') {
          newOffset = offset
        }
      }

      return { newOffset, newSpan }
    },

    // ------------------ 删除时间条 -------------------
    handleBarMouseupRight(bar) {
      this.handleCloseTimeRangePicker()

      const halfDiff = (bar.span - 300) / 2
      if (halfDiff > 0) {
        this.deleteBarPopPlace = 'top'
      } else {
        if (bar.offset + halfDiff <= 0) {
          this.deleteBarPopPlace = 'topLeft'
        } else if (bar.offset + Math.abs(halfDiff) + bar.span >= 1440) {
          this.deleteBarPopPlace = 'topRight'
        } else {
          this.deleteBarPopPlace = 'top'
        }
      }
      this.$nextTick(() => {
        this.$refs[`delete-${bar.id}`][0].click() 
      })
    },
    handleDeleteTimeBar(bar) {
      const times = this.barData.filter(item => item.id !== bar.id)
      this.$emit('changeTimes', times)
    },
    // ------------------------------------------------

    // ------------------ 时间选择器修改时间条 -------------------
    // 确认时间段选择
    handleConfirmTimeRange() {
      const fromTime = this.setFromTime.format('HH:mm:ss')
      const toTime = this.setToTime.format('HH:mm:ss')
      
      let times = this.barData.filter(bar => bar.id !== this.targetBar.id)
      times.push({ fromTime, toTime })

      // 抛出最新的时间段内容
      this.$emit('changeTimes', this.handleOverlapRange(times))
      this.handleCloseTimeRangePicker()
    },
    // 显示时间段选择器
    handleShowTimeRangePicker(bar) {
      this.targetBar = bar
      this.setFromTime = moment(bar.fromTime, 'HH:mm:ss')
      this.setToTime = moment(bar.toTime, 'HH:mm:ss')
      this.pickerPosition = this.setPickerPosition(bar)
      this.$nextTick(() => {
        !this.pickerVisible && this.$emit('changePickerVisible', true)
      })
    },
    // 关闭时间段选择器
    handleCloseTimeRangePicker() {
      this.targetBar = null
      this.setFromTime = null
      this.setToTime = null
      this.setTimeError = ''

      this.$nextTick(() => {
        this.$emit('changePickerVisible', false)
      })
    },
    // 时间段选择器位置设置
    setPickerPosition(bar) {
      let style = {}
      const halfDiff = (bar.span - 400) / 2
      if (halfDiff > 0) {
        style = { left: halfDiff + bar.offset + 'px' }
      } else {
        if (bar.offset + halfDiff <= 0) {
          style = { left: bar.offset + 'px' }
        } else if (bar.offset + Math.abs(halfDiff) + bar.span >= 1440) {
          style = { right: (1440 - bar.offset - bar.span) + 'px' }
        } else {
          style = { left: halfDiff + bar.offset + 'px' }
        }
      }
      return style
    },
    // 校验时间段
    validTimeRange() {
      if (!this.setFromTime) {
        this.setTimeError = 'timeConfig.pickerFromTimeBlank'
        return false
      }
      if (!this.setToTime) {
        this.setTimeError = 'timeConfig.pickerToTimeTxtBlank'
        return false
      }

      if (this.setToTime.format('HH:mm:ss') !== '00:00:00') {
        const diff = this.setToTime.diff(this.setFromTime, 'minutes')
        if (diff <= 0) {
          this.setTimeError = 'timeConfig.timeRangeErr'
          return false
        } else if (diff < 10) {
          this.setTimeError = 'timeConfig.timeRangeTiny'
          return false
        }
      }
      this.setTimeError = ''
      return true 
    },
    // 融合重叠时间段
    handleOverlapRange(times) {
      times.sort((prev, next) => {
        if (prev.fromTime > next.fromTime) return 1
        if (prev.fromTime < next.fromTime) return -1
        return 0
      })
      const newTimes = times.reduce((result, time) => {
        const len = result.length
        if (len) {
          const last = result.pop(len - 1)
          result = result.concat(this.mixinTwoTimeRanges(last, time))
        } else {
          result.push(time)
        }
        return result
      }, [])
      
      return newTimes
    },
    mixinTwoTimeRanges(prev, next) {
      const fromArr = [prev.fromTime, next.fromTime].sort()
      const toArr = [prev.toTime, next.toTime].sort()
      if (toArr[0] === '00:00:00') {
        const time = toArr[0]
        toArr[0] = toArr[1]
        toArr[1] = time
      }

      if (fromArr[1] <= toArr[0]) {
        return [{
          fromTime: fromArr[0],
          toTime: toArr[1]
        }]
      } else {
        return [{
          fromTime: fromArr[0],
          toTime: toArr[0]
        }, {
          fromTime: fromArr[1],
          toTime: toArr[1]
        }]
      }
    }
    // ---------------------------------------------------------
  }
}
</script>

<style lang="less" scoped>
.time-bar{
  width: 100%;
  height: 100%;
  position: relative;
  min-width: 144px;
  user-select: none;
  
  .draging-back-warp {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    // background-color: rgba(0,0,0,0.3);
    z-index: 1;
  }

  .bar-warp {
    position: absolute;
    height: 100%;
    display: flex;
    align-items: center;

    .bar{
      position: absolute;
      width: 100%;
      background-color:#1890ff;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: #f1f1f1;
      cursor: pointer;
      overflow: hidden;

      .time-str{
        text-overflow:ellipsis;
        white-space: nowrap;
        overflow: hidden;
        padding: 0px 5px;
      }
    }

    .drag-btn{
      position: absolute;
      color: #1890ff;
      font-size: 30px;
      cursor: pointer;
    }
    .drag-btn.left { left: -30px; }
    .drag-btn.right { right: -30px; }
  }

  .time-bar-edit{
    position: absolute;
    top: 45px;

    z-index: 2;
    padding: 10px 5px;
    background-color: #fff;
    box-shadow: 0px 0px 7px 1px #d9d9d9;
    border-radius: 4px;
    text-align: left;

    .time-range-picker{
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .error-msg{
      display: block;
      width: 270px;
      color:#FF4D4F;
      margin-top:5px;
      white-space: break-spaces;
    }
  }

  .new-time-bar{
    height: 100%;
    background-color:#188fff98;
    position: absolute;
    .time-flag{
      position: absolute;
      display: block;
      width: 50px;
      left: -25px;
      top: -20px;
      background-color: #1890ff;
      color: #fff;
      border-radius: 5px;
    }
    .time-flag.end {
      left: unset;
      right: -25px;
    }
  }
}
</style>
